import React from 'react';

const CloseIcon = (props) => {

  const { size, color, className, onClick } = props;

  return (
    <div className={className} onClick={onClick}>
        <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg">
            <rect width="1.88234" height="20.7101" transform="matrix(-0.707104 -0.70711 -0.707104 0.707109 16 1.35565)" fill={color}/>
            <rect width="1.88234" height="20.7101" transform="matrix(-0.707104 0.707109 0.707104 0.707109 1.33105 0)" fill={color}/>
        </svg>
    </div>
    );
}

export default CloseIcon;